import React, { Component } from 'react'
import { connect } from 'react-redux'
import RoleList from '../../components/RoleList'
import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import axios from 'axios'
import { Preloader } from '../../components/Chart/index'
import './style.css'
import Multi from '../../components/Multi'
import BorderButton from '../../components/BorderButton'
import Checkbox from '../../components/Checkbox'
import { push } from 'connected-react-router'
import Alert from 'react-s-alert'
import ReactTooltip from 'react-tooltip'

class Settings extends Component {
    state = {
        loading: false,
        parentRoles: [],
        parentRoleId: null,
        rolePermissions: [],
        ordering: {},
        checked: false
    }

    constructor(props) {
        super(props)

        console.log('EDIT role ', this.props.location.state.role)
        console.log('EDIT ? ', this.props.location.state.role !== null)

        // define a ordering for methods
        let ordering = {} // map for efficient lookup of sortIndex
        let sortOrder = ['GET', 'POST', 'PATCH', 'DELETE']
        for (var i = 0; i < sortOrder.length; i++) ordering[sortOrder[i]] = i

        this.state = {
            ordering: ordering,
            isEditing: this.props.location.state.role !== null,
            role: this.props.location.state.role || { roleName: '', roleId: '' }
        }
    }

    componentDidMount() {
        // load the parents roles
        this.setState({ loading: true }, () => {
            axios.get('/role?roleType=SYSTEM').then(response => {
                this.setState({ parentRoles: response.data.body, loading: false }, () => {
                    if (!this.state.isEditing) {
                        this.onParentRoleChange(this.state.parentRoles[0].roleId)
                    }
                })
            })
        })

        if (this.state.isEditing) {
            axios.get('/role/' + this.state.role.roleId).then(response => {
                this.setState({ rolePermissions: this.orderMethods(response.data.body), loading: false })
            })
        }
    }

    onSave(row, index) {
        this.setState({ disableButton: true, loading: true }, () => {
            let method = 'POST'
            let body = {}
            if (this.state.isEditing) {
                method = 'PATCH'
                body = {
                    roleId: this.state.role.roleId,
                    roleName: this.state.role.roleName,
                    created: new Date().getTime(),
                    apis: this.state.rolePermissions
                }
            } else {
                body = {
                    roleId: this.state.role.roleId,
                    roleName: this.state.role.roleName,
                    apis: this.state.rolePermissions
                }
            }
            axios
                .request({ url: '/role', method: method, data: body })
                .then(response => {
                    console.log('successfully saved a new role!', response)
                    this.props.history.push('/roles')
                })
                .catch(err => {
                    this.setState({ loading: false })
                })
        })
    }

    onParentRoleChange(roleId) {
        this.setState({ rolePermissions: [], parentRoleId: roleId, loading: true }, () => {
            axios
                .request({ url: '/role/' + roleId, method: 'GET' })
                .then(response => {
                    this.setState({ loading: false, rolePermissions: this.orderMethods(response.data.body) })
                })
                .catch(err => {
                    this.setState({ loading: false })
                })
        })
    }

    /* order based on a custom indexes, we want GET then POST, ... method in order */
    orderMethods(apis) {
        for (let i = 0; i < apis.length; i++) {
            let api = apis[i]

            api.methods.sort((a, b) => {
                return this.state.ordering[a.method] - this.state.ordering[b.method]
            })
        }

        return apis
    }

    onChangeActiveMethod(indexApi, methodName) {
        let rolePermissions = this.state.rolePermissions
        let method = rolePermissions[indexApi].methods.find(el => el.method === methodName)
        // if method exists
        if (method) {
            method.active = !method.active
            this.setState({
                rolePermissions: rolePermissions
            })
        } else {
            Alert.error('this method is not available for this API!')
        }
    }

    render() {
        const disabled = this.state.role.roleName === ''
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-10">
                            <WhiteBox>
                                <div
                                    style={{
                                        position: 'relative',
                                        paddingRight: 100
                                    }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src="/img/audience/illy-segment-based-audience.svg" alt="" />
                                        </div>
                                        <div className="col">
                                            <div className="row">
                                                <div className="col-4">
                                                    <h3 style={{ marginTop: 26 }}>{this.state.isEditing ? 'EDIT' : 'CREATE'} ROLE</h3>
                                                </div>
                                                <div className="col">
                                                    <h3 style={{ marginTop: 26 }}> API Permissions</h3>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-4">
                                                    <p style={{ marginTop: 30 }}>Role Name *</p>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.role.roleName}
                                                        onChange={event => {
                                                            let role = this.state.role
                                                            role['roleName'] = event.target.value
                                                            this.setState({ role: role })
                                                        }}
                                                    />

                                                    <p style={{ marginTop: 30 }}>Parent Permissions {!this.state.isEditing && <span>*</span>}</p>
                                                    <select
                                                        className="form-control"
                                                        value={this.state.parentRoleId}
                                                        onChange={({ target }) => this.onParentRoleChange(target.value)}>
                                                        {this.state.isEditing && (
                                                            <option key={'empty_role'} value="">
                                                                Please select
                                                            </option>
                                                        )}
                                                        {this.state.parentRoles &&
                                                            this.state.parentRoles.map(el => {
                                                                return (
                                                                    <option key={el.roleId} value={el.roleId}>
                                                                        {el.roleName}
                                                                    </option>
                                                                )
                                                            })}
                                                    </select>
                                                </div>
                                                <div className="col" style={{ 'border-left': '1px solid #eee', 'padding-left': '20px' }}>
                                                    <table className="license-list license-list--table">
                                                        <thead>
                                                            <tr className="audience-list audience-list--header">
                                                                <th className="audience-list audience-list--audience" className="col-4">
                                                                    API
                                                                </th>
                                                                <th className="audience-list audience-list--audience api-methods col">LIST</th>
                                                                <th className="audience-list audience-list--audience api-methods col">CREATE</th>
                                                                <th className="audience-list audience-list--audience api-methods col">UPDATE</th>
                                                                <th className="audience-list audience-list--audience api-methods col">DELETE</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.rolePermissions &&
                                                                this.state.rolePermissions.map((api, indexApi) => (
                                                                    <tr key={'api_' + indexApi} className={`audience-list audience-list--row }`}>
                                                                        <td className="col-4 audience-list audience-list--audience">{api.api}</td>

                                                                        {['GET', 'POST', 'PATCH', 'DELETE'].map((methodName, indexMethod) => {
                                                                            let apiMethod = api.methods.find(el => el.method === methodName)
                                                                            return (
                                                                                <td
                                                                                    key={api.api + '_' + indexMethod}
                                                                                    className="api-methods col"
                                                                                    style={{ textAlign: 'center' }}>
                                                                                    <ReactTooltip
                                                                                        id={'tooltipMethod_' + api.api + '_' + indexMethod}
                                                                                        type="dark"
                                                                                        effect="solid">
                                                                                        <span>{methodName + ': ' + api.api}</span>
                                                                                    </ReactTooltip>
                                                                                    <label data-tip data-for={'tooltipMethod_' + api.api + '_' + indexMethod}>
                                                                                        <Checkbox
                                                                                            disabled={!apiMethod || apiMethod == null}
                                                                                            checked={apiMethod && apiMethod.active}
                                                                                            onChange={() => this.onChangeActiveMethod(indexApi, methodName)}
                                                                                        />
                                                                                    </label>
                                                                                </td>
                                                                            )
                                                                        })}
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {this.state.loading && <Preloader transparent />}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <div className="new-segment-based-audience new-segment-based-audience--button-group">
                                                <BorderButton className="grey" label="Cancel" onClick={() => (window.location.href = '/roles')} />
                                                <BorderButton label="SAVE" onClick={this.onSave.bind(this)} disabled={disabled} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </WhiteBox>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Settings)
